import React, { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography
} from "@mui/material";
import { useUserAuth } from "../../contexts/authContext";

export default function InfrastructureDialog(props) {
    const { snackbar, setSnackbar, handleFailedFetch } = useUserAuth();

    const row = props.row;
    const [coords] = useState(row.coordinates);
    const [name, setName] = useState(row.name);
    const [type, setType] = useState(row.type_id);
    const [assessment, setAssessment] = useState(row.assessment ? "true" : "false");
    const [description, setDescription] = useState(row.description);

    const handleSubmit = async () => {
        if (!coords) {
            return setSnackbar({ children: "The infrastructure asset is invalid.", severity: "error" });
        } else if (!name || !type || !assessment) {
            return setSnackbar({ children: "Please fill in the below fields.", severity: "error" });
        }

        const infrastructureAsset = {
            id: row.id,
            coordinates: JSON.stringify(coords),
            name,
            type_id: type,
            assessment,
            description
        };
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(infrastructureAsset)
        };
        await fetch("/api/infrastructure/assets/insertUpdate", requestOptions).catch((err) => handleFailedFetch(err));

        props.handleClose();
    };

    return (
        <Dialog
            onClose={props.handleClose}
            open={props.infrastructureDialogOpen}
            maxWidth="lg"
            PaperProps={{ sx: { width: { xs: "100%", sm: "auto" }, minWidth: { sm: "500px" } } }}
        >
            <DialogTitle>Edit Infrastructure</DialogTitle>
            <DialogContent sx={{ pb: 0, pt: 0 }}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: { sm: "10px" }, mt: "-10px" }}>
                        <TextField
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            margin="normal"
                            fullWidth
                            label="Name"
                            id="editName"
                            error={snackbar && !name}
                        />
                        <TextField value={type} onChange={(e) => setType(e.target.value)} margin="normal" fullWidth label="Type" id="editType" select>
                            {props.infrastructureTypes.map((type, i) => (
                                <MenuItem key={i} value={type.id} id={type.name}>
                                    {type.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Box>
                    <TextField
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        margin="normal"
                        label="Description"
                        id="editDescription"
                        sx={{ pb: "4px" }}
                    />
                    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <Typography variant="body2" color="text.secondary">
                            Assessment
                        </Typography>
                        <ToggleButtonGroup
                            exclusive
                            fullWidth
                            margin="normal"
                            value={assessment}
                            onChange={(e) => setAssessment(e.target.value)}
                            color="primary"
                        >
                            <ToggleButton value="true" color="success" id="assessed">
                                Assessed
                            </ToggleButton>
                            <ToggleButton value="false" color="error" id="notAssessed">
                                Not Assessed
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button sx={{ mr: "auto" }} onClick={props.handleClose} data-testid="close">
                    Close
                </Button>
                <Button onClick={handleSubmit} data-testid="save" id="save">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}
